export class MeterAlreadyRegisteredError extends Error {
  constructor() {
    super("The provided meter is already registered.");
    this.name = "MeterAlreadyRegisteredError";
  }
}
